// import React, { useState } from "react";
// import { BASE_URL, IMAGE_URL } from "../../config/axios";
// import { handleErrorToast } from "../custom";
// import { ToastContainer, toast } from "react-toastify";
// import axios from "axios";

// const EmployeeDetailCard = ({ getAllEmployee, filteredEmployee }) => {
//     const [loading, setLoading] = useState(false); // Loading logic

//     const handleAllProjectChange = async (empCode, currentAllProjectStatus) => {
//         setLoading(true); // Set loading state
//         const loadingToastId = toast.loading("Loading: Please wait..."); // Toast logic
//         const formdata = currentAllProjectStatus === true ?
//             {
//                 view_all_project: !currentAllProjectStatus, // Toggle the PR status
//                 edit_project_access: false,
//                 delete_project_access: false
//             }
//             :
//             { view_all_project: !currentAllProjectStatus }
//         try {
//             const res = await axios.put(`${BASE_URL}/wfm/ourcompanyuserdetail/${empCode}/`, formdata);

//             if (res.status === 200) {
//                 toast.update(loadingToastId, {
//                     render: "All Project View status updated successfully!",
//                     type: "success",
//                     isLoading: false,
//                     autoClose: 3000,
//                 });
//                 await getAllEmployee(); // Refresh the employee list
//             }
//         } catch (err) {
//             handleErrorToast(err, loadingToastId); // Handle error toast
//         } finally {
//             setLoading(false); // Reset loading state
//             toast.dismiss(loadingToastId);
//         }
//     };

//     const handlePRChange = async (empCode, currentPRStatus) => {
//         setLoading(true); // Set loading state
//         const loadingToastId = toast.loading("Loading: Please wait..."); // Toast logic

//         try {
//             const res = await axios.put(`${BASE_URL}/wfm/ourcompanyuserdetail/${empCode}/`, {
//                 pr_project: !currentPRStatus, // Toggle the PR status
//             });

//             if (res.status === 200) {
//                 toast.update(loadingToastId, {
//                     render: "PR status updated successfully!",
//                     type: "success",
//                     isLoading: false,
//                     autoClose: 3000,
//                 });
//                 await getAllEmployee(); // Refresh the employee list
//             }
//         } catch (err) {
//             handleErrorToast(err, loadingToastId); // Handle error toast
//         } finally {
//             setLoading(false); // Reset loading state
//             toast.dismiss(loadingToastId);
//         }
//     };

//     const handleEditchange = async (empCode, currentPRStatus) => {
//         setLoading(true); // Set loading state
//         const loadingToastId = toast.loading("Loading: Please wait..."); // Toast logic

//         try {
//             const res = await axios.put(`${BASE_URL}/wfm/ourcompanyuserdetail/${empCode}/`, {
//                 edit_project_access: !currentPRStatus, // Toggle the PR status
//             });

//             if (res.status === 200) {
//                 toast.update(loadingToastId, {
//                     render: "Edit status updated successfully!",
//                     type: "success",
//                     isLoading: false,
//                     autoClose: 3000,
//                 });
//                 await getAllEmployee(); // Refresh the employee list
//             }
//         } catch (err) {
//             handleErrorToast(err, loadingToastId); // Handle error toast
//         } finally {
//             setLoading(false); // Reset loading state
//             toast.dismiss(loadingToastId);
//         }
//     };

//     const handleDeletechange = async (empCode, currentPRStatus) => {
//         setLoading(true); // Set loading state
//         const loadingToastId = toast.loading("Loading: Please wait..."); // Toast logic

//         try {
//             const res = await axios.put(`${BASE_URL}/wfm/ourcompanyuserdetail/${empCode}/`, {
//                 delete_project_access: !currentPRStatus, // Toggle the PR status
//             });

//             if (res.status === 200) {
//                 toast.update(loadingToastId, {
//                     render: "Delete status updated successfully!",
//                     type: "success",
//                     isLoading: false,
//                     autoClose: 3000,
//                 });
//                 await getAllEmployee(); // Refresh the employee list
//             }
//         } catch (err) {
//             handleErrorToast(err, loadingToastId); // Handle error toast
//         } finally {
//             setLoading(false); // Reset loading state
//             toast.dismiss(loadingToastId);
//         }
//     };

//     return (
//         <div className="employee-cards">
//             {filteredEmployee
//                 .sort((a, b) => a.emp_code - b.emp_code)
//                 .map((e) => (
//                     <div className="employee-card" key={e.emp_code}>
//                         <div className="employee-card-a">
//                             <div className="employee-card-image">
//                                 <div className="employee-card-image-background">
//                                     <img
//                                         src={
//                                             e.profilepic
//                                                 ? `${IMAGE_URL}${e.profilepic}`
//                                                 : "https://images.unsplash.com/photo-1511367461989-f85a21fda167?q=80&w=1931&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
//                                         }
//                                         alt="card-pic"
//                                         className="employee-card-imageee"
//                                     />
//                                 </div>
//                                 <div className="employee-card-icons">
//                                     <div className="employee-card-name font-weight500 font-size-subheading">
//                                         {e.name}
//                                     </div>
//                                     <div className="employee-card-designation font-weight400 font-size-subheading">
//                                         {e.designation_name}
//                                     </div>
//                                     <div className="employee-card-name font-weight500 font-size-subheading">
//                                         Emp Code: {e.emp_code}
//                                     </div>
//                                 </div>
//                             </div>


//                         </div>

//                         <div className="employee-info-grid">
//                             <div className="cart-subdiv-flex">
//                                 <span className="employee-card-b-heading font-weight400 font-size-label">
//                                     Department :
//                                 </span>
//                                 <span className="employee-card-b-text font-weight400 font-size-label block">
//                                     {e.department_name}
//                                 </span>
//                             </div>

//                             <div className="cart-subdiv-flex word-wrap-vw" >
//                                 <span className="employee-card-b-heading font-weight400 font-size-label">
//                                     Email :
//                                 </span>
//                                 <span className="employee-card-b-text font-weight400 font-size-label block" >
//                                     {" "}{e.user_detail}
//                                 </span>
//                             </div>
//                             <div className="cart-subdiv-flex">
//                                 <span className="employee-card-b-heading font-weight400 font-size-label">
//                                     Mobile No :
//                                 </span>
//                                 <span className="employee-card-b-text font-weight400 font-size-label block">
//                                     {e.mobile_number}
//                                 </span>
//                             </div>
//                             <div className="cart-subdiv-flex">
//                                 <span className="employee-card-b-heading font-weight400 font-size-label">
//                                     Location :
//                                 </span>
//                                 <span
//                                     className="employee-card-b-text font-weight400 font-size-label block"

//                                 >
//                                     {e.location_name}
//                                 </span>
//                             </div>

//                         </div>
//                         <hr className="line" />


//                         <div className="employee-info-grid" style={{ marginBottom: "25px" }}>
//                             <div className="flex-row-jc" >
//                                 {
//                                     loading ? <div className="spinner-small"></div> :
//                                         <div className="checkbox-toggle">
//                                             <input
//                                                 type="checkbox"
//                                                 id={`toggle_all_${e.emp_code}`}
//                                                 name="pr_toggle"
//                                                 checked={e.view_all_project || false}
//                                                 onChange={() => handleAllProjectChange(e.emp_code, e.view_all_project)}
//                                             />
//                                             <label htmlFor={`toggle_all_${e.emp_code}`}></label>
//                                         </div>
//                                 }
//                                 <hr
//                                     style={{ marginTop: "10px" }}
//                                     className="field-cont-hr"
//                                 />

//                                 <label
//                                     htmlFor={`toggle_all_${e.emp_code}`}
//                                     className="form-labels font-weight200 font-size-label width-5vw"
//                                 >
//                                     {e.view_all_project ? "View" : "Hide"} All
//                                 </label>

//                             </div>
//                             <div className="flex-row-jc">
//                                 {loading ? <div className="spinner-small"></div> :
//                                     <div className="checkbox-toggle">
//                                         <input
//                                             type="checkbox"
//                                             id={`toggle_pr_${e.emp_code}`}
//                                             name="pr_toggle"
//                                             checked={e.pr_project || false} // Use e.pr_project for default value
//                                             onChange={() => handlePRChange(e.emp_code, e.pr_project)}
//                                         />
//                                         <label htmlFor={`toggle_pr_${e.emp_code}`}></label>
//                                     </div>
//                                 }
//                                 <hr
//                                     style={{ marginTop: "10px" }}
//                                     className="field-cont-hr"
//                                 />
//                                 <label
//                                     htmlFor={`toggle_pr_${e.emp_code}`}
//                                     className="form-labels font-weight200 font-size-label width-5vw"
//                                 >
//                                     {e.pr_project ? "View" : "Hide"} PR
//                                 </label>

//                             </div>
//                             <div className="flex-row-jc">
//                                 {loading ? <div className="spinner-small"></div> :
//                                     <div className="checkbox-toggle">
//                                         <input
//                                             type="checkbox"
//                                             id={`toggle_edit_project_access_${e.emp_code}`}
//                                             name="edit_project_access"
//                                             checked={e.edit_project_access || false} // Use e.pr_project for default value
//                                             onChange={() => handleEditchange(e.emp_code, e.edit_project_access)}
//                                         />
//                                         <label htmlFor={`toggle_edit_project_access_${e.emp_code}`}></label>
//                                     </div>
//                                 }
//                                 <hr
//                                     style={{ marginTop: "10px" }}
//                                     className="field-cont-hr"
//                                 />
//                                 <label
//                                     htmlFor={`toggle_edit_project_access_${e.emp_code}`}
//                                     className="form-labels font-weight200 font-size-label width-5vw"
//                                 >
//                                     {e.edit_project_access ? "View" : "Hide"} Edit
//                                 </label>

//                             </div>
//                             <div className="flex-row-jc">
//                                 {loading ? <div className="spinner-small"></div> :
//                                     <div className="checkbox-toggle">
//                                         <input
//                                             type="checkbox"
//                                             id={`toggle_delete_project_access_${e.emp_code}`}
//                                             name="delete_project_access"
//                                             checked={e.delete_project_access || false} // Use e.pr_project for default value
//                                             onChange={() => handleDeletechange(e.emp_code, e.delete_project_access)}
//                                         />
//                                         <label htmlFor={`toggle_delete_project_access_${e.emp_code}`}></label>
//                                     </div>
//                                 }
//                                 <hr
//                                     style={{ marginTop: "10px" }}
//                                     className="field-cont-hr"
//                                 />
//                                 <label
//                                     htmlFor={`toggle_delete_project_access_${e.emp_code}`}
//                                     className="form-labels font-weight200 font-size-label width-5vw"
//                                 >
//                                     {e.delete_project_access ? "View" : "Hide"} Delete
//                                 </label>

//                             </div>
//                         </div>


//                     </div>
//                 ))}
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         </div>
//     );
// };

// export default EmployeeDetailCard;

import React, { useState } from "react";
import { BASE_URL, IMAGE_URL } from "../../config/axios";
import { handleErrorToast } from "../custom";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";

const EmployeeDetailCard = ({ getAllEmployee, filteredEmployee }) => {
    const [loadingState, setLoadingState] = useState({}); // Track loading per employee & action

    const setEmployeeLoading = (empCode, action, isLoading) => {
        setLoadingState((prev) => ({
            ...prev,
            [empCode]: { ...prev[empCode], [action]: isLoading },
        }));
    };

    const handleUpdate = async (empCode, field, currentValue) => {
        setEmployeeLoading(empCode, field, true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        const updateData = { [field]: !currentValue };
        if (field === "view_all_project" && currentValue) {
            updateData.edit_project_access = false;
            updateData.delete_project_access = false;
        }

        try {
            const res = await axios.put(`${BASE_URL}/wfm/ourcompanyuserdetail/${empCode}/`, updateData);
            if (res.status === 200) {
                toast.update(loadingToastId, {
                    render: `${field.replace("_", " ").toUpperCase()} updated successfully!`,
                    type: "success",
                    isLoading: false,
                    autoClose: 3000,
                });
                await getAllEmployee();
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setEmployeeLoading(empCode, field, false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <div className="employee-cards">
            {filteredEmployee
                .sort((a, b) => a.emp_code - b.emp_code)
                .map((e) => (
                    <div className="employee-card" key={e.emp_code}>
                        <div className="employee-card-a">
                            <div className="employee-card-image">
                                <div className="employee-card-image-background">
                                    <img
                                        src={
                                            e.profilepic
                                                ? `${IMAGE_URL}${e.profilepic}`
                                                : "https://images.unsplash.com/photo-1511367461989-f85a21fda167?q=80&w=1931&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                                        }
                                        alt="card-pic"
                                        className="employee-card-imageee"
                                    />
                                </div>
                                <div className="employee-card-icons">
                                    <div className="employee-card-name font-weight500 font-size-subheading">
                                        {e.name}
                                    </div>
                                    <div className="employee-card-designation font-weight400 font-size-subheading">
                                        {e.designation_name}
                                    </div>
                                    <div className="employee-card-name font-weight500 font-size-subheading">
                                        Emp Code: {e.emp_code}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="employee-info-grid">
                            <div className="cart-subdiv-flex">
                                <span className="employee-card-b-heading font-weight400 font-size-label">
                                    Department :
                                </span>
                                <span className="employee-card-b-text font-weight400 font-size-label block">
                                    {e.department_name}
                                </span>
                            </div>
                            <div className="cart-subdiv-flex word-wrap-vw">
                                <span className="employee-card-b-heading font-weight400 font-size-label">
                                    Email :
                                </span>
                                <span className="employee-card-b-text font-weight400 font-size-label block">
                                    {e.user_detail}
                                </span>
                            </div>
                            <div className="cart-subdiv-flex">
                                <span className="employee-card-b-heading font-weight400 font-size-label">
                                    Mobile No :
                                </span>
                                <span className="employee-card-b-text font-weight400 font-size-label block">
                                    {e.mobile_number}
                                </span>
                            </div>
                            <div className="cart-subdiv-flex">
                                <span className="employee-card-b-heading font-weight400 font-size-label">
                                    Location :
                                </span>
                                <span className="employee-card-b-text font-weight400 font-size-label block">
                                    {e.location_name}
                                </span>
                            </div>
                        </div>
                        <hr className="line" />
                        <div className="employee-info-grid" style={{ marginBottom: "25px" }}>
                            {["view_all_project", "pr_project", "edit_project_access", "delete_project_access"].map((field) => (
                                <div className="flex-row-jc" key={field}>
                                    {loadingState[e.emp_code]?.[field] ? <div className="spinner-small"></div> : (
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                id={`toggle_${field}_${e.emp_code}`}
                                                name={field}
                                                checked={e[field] || false}
                                                onChange={() => handleUpdate(e.emp_code, field, e[field])}
                                            />
                                            <label htmlFor={`toggle_${field}_${e.emp_code}`}></label>
                                        </div>
                                    )}
                                    <hr style={{ marginTop: "10px" }} className="field-cont-hr" />
                                    <label
                                        htmlFor={`toggle_${field}_${e.emp_code}`}
                                        className="form-labels font-weight200 font-size-label width-5vw"
                                    >
                                        {e[field] ? "View" : "Hide"}{" "}
                                        {field === "view_all_project"
                                            ? "All"
                                            : field === "pr_project"
                                                ? "PR"
                                                : field === "edit_project_access"
                                                    ? "Edit"
                                                    : field === "delete_project_access"
                                                        ? "Delete"
                                                        : field.replace("_", " ")}
                                    </label>

                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
};

export default EmployeeDetailCard;

